import Vue from 'vue'
import { Form, Button, Input, Steps, Modal, Checkbox, Radio, Icon, message, Upload } from 'ant-design-vue'
import Storage from 'vue-ls'
import SliderCaptcha from '@/components/slider-captcha'
import VerificationCode from '@/components/verification-code'
import MobileInput from '@/components/mobile-input'

import './css/index.less'

Vue.use(Form)
Vue.use(Button)
Vue.use(Input)
Vue.use(Steps)
Vue.use(Checkbox)
Vue.use(Radio)
Vue.use(Icon)
Vue.use(Upload)
Vue.use(Modal)
Vue.prototype.$error = Modal.error
Vue.prototype.$success = Modal.success
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$info = Modal.info
Vue.prototype.$message = message
Vue.use(SliderCaptcha)
Vue.use(VerificationCode)
Vue.use(Storage)
Vue.use(MobileInput)
